import { NextButton, SecondaryButton } from "@/components/buttons/Buttons";
import CardContainer from "@/components/cards/CardContainer";
import Container, { Column, Row } from "@/components/container/Container";
import Spacing from "@/components/container/Spacing";
import { ListWithIcon } from "@/components/text/Lists";
import { TextHeadlineExtraExtraLarge, TextHeadlineLarge, TextLabelLarge } from "@/components/text/Texts";
import { MdCheck } from "react-icons/md";
import './concierge.styles.css';
import ConciergeFaqAccordion from "./ConciergeFaqAccordion";
import ConciergeServiceCards from "./ConciergeServiceCards";
import { useNavigate } from "react-router-dom";
import routes, { routeWithId } from "@/constants/routes";

const KEY_BENEFITS = [
	'No app required for passengers',
	'Request rides now or schedule trips',
	'Same-day package delivery',
];

const ConciergeStartScreen = () => {
	const navigate = useNavigate();

	return (
		<Column className="gap-[24px] concierge-start-screen">
			<CardContainer>
				<Row className="gap-4 p-[32px] tablet:p-4">
					<Column className="py-4 w-1/2">
						<TextHeadlineExtraExtraLarge text="Concierge" className="text-primary font-semibold" />
						<Spacing height="h-[20px]" />
						<TextLabelLarge text="Simplify Transportation for Everyone: Request Rides for Employees, Customers, and Guests - No App Needed" />
						<Spacing height="h-[24px]" />
						<ListWithIcon
							icon={<MdCheck size={24} className="text-info" />}
							listItems={KEY_BENEFITS}
							gapBetweenIconAndText="gap-[10px]"
							gapBetweenListItems="gap-3"
						/>
						<Spacing height="h-[28px]" />
						<Row gap="gap-[20px]">
							<NextButton
								id="concierge-next"
								label="Get started"
								width="w-[169px]"
								withIcon
								onClick={() => navigate('/concierge/statuses/0')}
							/>
							{/* <SecondaryButton
								id="concierge-view"
								label="View product demo"
								width="w-[228px]"
								onClick={() => { }}
							/> */}
						</Row>
					</Column>
					<Container className="flex self-end h-full w-1/2">
						<img src="/images/concierge_banner.png" alt="concierge image" className="max-w-full h-auto object-contain" />
					</Container>
				</Row>
			</CardContainer>

			<TextHeadlineLarge text="Services" />
			<ConciergeServiceCards></ConciergeServiceCards>

			<TextHeadlineLarge text="Questions" />
			<ConciergeFaqAccordion />

			<Spacing height="h-[8px]" />
		</Column>
	);
};

export default ConciergeStartScreen;
